import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
	selector: 'app-textarea-control',
	standalone: true,
	imports: [ReactiveFormsModule, NzFormModule, NzInputModule],
	templateUrl: './textarea-control.html',
})
export class TextareaControl {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	minLength = input<number | null>(null);
	rows = input<number>(4);
	formGroup = input.required<FormGroup>();
}
